module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userportalbody"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bdf9014c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user.vue
// module id = 1655
// module chunks = 32